import React from 'react';
import PropTypes from 'prop-types';
import styles from '../ArticleComponents.module.css';

// import { LazyLoadComponent } from 'react-lazy-load-image-component';

export default class GalleryComponent extends React.Component {
	intervalTime = 5000;

	state = {
		images: [],
		index: 0,
	};

	componentDidMount() {
		const { images } = this.props;

		if (images.length) {
			this.downloadImages(images)
				.then(()=> {
					console.log(`Success downloading images in gallery`)
				})
				.catch(console.error)
			this.interval = setInterval(() => {
				if (this.state.index === images.length - 1) {
					this.setState({ index: 0 });
				} else {
					this.setState({ index: this.state.index + 1 });
				}
			}, this.intervalTime);
		}
	}

	downloadImages = async (images) => {
		const promises = [];
		for(const image of images) {
			const {imageurl} = image;
			promises.push(fetch(imageurl));
		}

		return Promise.all(promises);
	}

	onImageChange(index) {
		const { images } = this.props;
		clearInterval(this.interval);
		this.interval = setInterval(() => {
			if (this.state.index === images.length - 1) {
				this.setState({ index: 0 });
			} else {
				this.setState({ index: this.state.index + 1 });
			}
		}, this.intervalTime);
		this.setState({ index });
	}

	onNext = () => {
		const { images } = this.props;
		if (this.state.index === images.length - 1) {
			this.onImageChange(0);
		} else {
			this.onImageChange(this.state.index + 1);
		}
	};

	onPrevious = () => {
		const { images } = this.props;
		if (this.state.index === 0) {
			this.onImageChange(images.length - 1);
		} else {
			this.onImageChange(this.state.index - 1);
		}
	};

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	render() {
		const { readerMode, component, mediaStyle } = this.props;
		let { lang } = this.props;
		const { id } = component;
		let { images } = this.props;
		let dotComponents = null;
		let prevArrow = null;
		let nextArrow = null;

		if (!lang) {
			lang = localStorage.getItem('language')
				? localStorage.getItem('language')
				: 'en';
		}

		const containerStyle = {
			width: '100%',
		};

		if (readerMode) {
			containerStyle.height = 0;
			containerStyle.maxHeight = 0;
			containerStyle.display = 'none';
		}

		if(mediaStyle?.component_bottom_margin) {
			containerStyle.marginBottom = `${mediaStyle.component_bottom_margin}px`
		}

		if (images.length > 1) {
			dotComponents = (
				<div className={styles['component-gallery-dot-container']}>
					{images.map((_, i) => {
						return (
							<span
								key={i}
								className={
									i === this.state.index
										? styles['component-gallery-dot-active']
										: styles['component-gallery-dot']
								}
								onClick={() => {
									this.onImageChange(i);
								}}
							/>
						);
					})}
				</div>
			);
			prevArrow = (
				<div
					className={styles['component-gallery-prev']}
					onClick={this.onPrevious}
				>
					&#10094;
				</div>
			);
			nextArrow = (
				<div
					className={styles['component-gallery-next']}
					onClick={this.onNext}
				>
					&#10095;
				</div>
			);
		}

		return (
			<div
				id={id}
				className={styles['component-gallery-container']}
				style={containerStyle}
			>
				{images.map((image, i) => {
					const { caption } = image;
					const style = {};
					if (this.state.index === i) {
						style.display = 'block';
					}

					const url = image['imagelink'];

					let onClick = () => {};
					if (url) {
						style.cursor = 'pointer';
						onClick = () => {
							window.open(url);
						};
					}

					return (
						<div
							className={`${styles['component-gallery-slides']} 
								${styles['fade']}`}
							key={i}
							style={style}
						>
							<img
								onClick={onClick}
								src={`${image.imageurl}`}
								alt={`Gallery Item ${i}`}
							/>
							{lang && caption && caption[lang] ? (
								<div>
									<small>{caption[lang]}</small>
								</div>
							) : null}
						</div>
					);
				})}
				{prevArrow}
				{nextArrow}
				{dotComponents}
			</div>
		);
	}
}

GalleryComponent.propTypes = {
	component: PropTypes.object.isRequired,
	readerMode: PropTypes.bool,
	images: PropTypes.array.isRequired,
	lang: PropTypes.string,
	mediaStyle: PropTypes.object
};
